export default "__VITE_ASSET__f1429960__"